// extracted by mini-css-extract-plugin
export var container = "style-module--container--58e8d";
export var detail = "style-module--detail--cc7f0";
export var heading = "style-module--heading--dfc48";
export var statistics = "style-module--statistics--758db";